import script from "./SmallCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallCard.vue?vue&type=script&setup=true&lang=js"

import "./SmallCard.vue?vue&type=style&index=0&id=164b3ef2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164b3ef2"]])

export default __exports__